import { AtIcon, PhoneIcon } from "@xola/icons";
import clsx from "clsx";
import React, { ReactNode } from "react";

window.enableDebug = () => {
    if (!window.flags) {
        window.flags = {};
    }

    if (window.flags.debug) {
        return console.log("Debug mode already enabled", window.flags);
    }

    console.log("%cRight-click here & click 'Save as' to save the output and send it to the dev team.", "color:green");
    window.flags.debug = true;
    console.log("Debug mode enabled", window.flags);
};

export const SupportInfo = () => {
    return (
        <div className="space-y-4">
            <h2>Xola Support</h2>
            <p>
                We are happy to help. You can goto{" "}
                <a target="_blank" href="https://support.xola.com" rel="noreferrer">
                    support.xola.com
                </a>{" "}
                to find answers to common questions or find us here for a more personalized experience:
            </p>
            <div className="grid w-full grid-cols-2 gap-8 xl:w-1/2">
                <InfoBlock className="no-translate">
                    <PhoneIcon size="large" className="text-green-darker" />
                    <a href="tel:4154049652">(415) 404-9652</a>
                </InfoBlock>
                <InfoBlock className="no-translate">
                    <AtIcon size="large" className="text-orange-darker" />
                    <a href="mailto:support@xola.com">support@xola.com</a>
                </InfoBlock>
            </div>
        </div>
    );
};

const InfoBlock = ({ children, className }: { children: ReactNode; className?: string }) => {
    return (
        <div
            className={clsx(
                "flex flex-col items-start justify-center gap-y-4 rounded border border-gray p-4 hover:cursor-default hover:bg-gray-hover",
                className,
            )}
        >
            {children}
        </div>
    );
};
